import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { CreateLearner, CreateLearnerError, CreateLearnerSuccess } from "./create-learner.actions";
import { catchError, map, mergeMap, withLatestFrom } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { selectLearnerDto } from "./create-learner.selectors";
import { of } from "rxjs";
import { Userprofile } from "src/app/_models/Userprofile";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class CreateLearnerEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private userProfileSerivce: UserProfileService
  ){}

  public createLearnerEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(CreateLearner),
      withLatestFrom(this.store.select(selectLearnerDto)),
      mergeMap(([_,learnerDto]) => {
        return this.userProfileSerivce.addLearnerProfile$(learnerDto).pipe(
          map((result: Userprofile) => {
            return CreateLearnerSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(CreateLearnerError({error: error}))
          })
        )
      })
    )
  );
}